<template>
  <populate-form
    formTitle="供應商資訊"
    fkey="mi01"
    ref="merchantInfoForm"
    populateOptionVar="merchantFormItems"
    formDataObjVar="FocusedMerchant"
    :validatePrompt="false"
    :parentVue="this"
  ></populate-form>
</template>

<script>

export default {
  name: 'MerchantInfo',
  components: {
    
  },
  props: {
    'cbSave':{
      type:Function,
      default: function () {
        return
      }
    },
    'cbCancel':{
      type:Function,
      default: function () {
        return
      }
    },
    'parentVue':Object,
  },
  data: function () {
    return {
      merchantFormItems:[
        {
          'componentType':'span',
          'akey':'span1',
          'col':2,
          'placeholder':'廠商代號',
          'title':'',
        },
        {
          'componentType':'text',
          'akey':'supplier_id',
          'col':4,
          'placeholder':'廠商代號',
          'disabled':true,
        },
        {
          'componentType':'span',
          'akey':'span2',
          'col':2,
          'placeholder':'供應商名稱',
          'title':'',
        },
        {
          'componentType':'text',
          'akey':'merchant_name',
          'col':4,
          'placeholder':'供應商名稱',
          'disabled':true,
        },
        {
          'componentType':'span',
          'akey':'span3',
          'col':2,
          'placeholder':'供應商全稱',
          'title':'',
        },
        {
          'componentType':'text',
          'akey':'merchant_description',
          'col':10,
          'placeholder':'供應商全稱',
          'disabled':true,
        },
        {
          'componentType':'span',
          'akey':'span4',
          'col':2,
          'placeholder':'供應商地址',
          'title':'',
        },
        {
          'componentType':'text',
          'akey':'supplier_address',
          'col':10,
          'placeholder':'供應商地址',
        },
        {
          'componentType':'span',
          'akey':'span5',
          'col':2,
          'placeholder':'統編',
          'title':'',
        },
        {
          'componentType':'text',
          'akey':'identity_id',
          'col':4,
          'placeholder':'統編',
          'disabled':false,
        },
        {
          'componentType':'span',
          'col':2,
          'placeholder':'發票/收據',
          'title':'',
        },
        {
          'componentType':'b-form-select',
          'dataOptions':[{'value':'invoice','text':'發票'},{'value':'receipt','text':'收據'},{'value':null,'text':'未定義'}],
          'akey':'invoice_type',
          'col':4,
          'placeholder':'發票/收據',
        },
        {
          'componentType':'span',
          'akey':'span7',
          'col':12,
          'placeholder':'聯絡人資訊',
          'title':'',
        },
        {
          'componentType':'span',
          'akey':'span8',
          'col':2,
          'placeholder':'負責人',
          'title':'',
        },
        {
          'componentType':'text',
          'akey':'person_in_charge',
          'col':4,
          'placeholder':'負責人',
        },
        {
          'componentType':'span',
          'akey':'span9',
          'col':2,
          'placeholder':'email',
          'title':'',
        },
        {
          'componentType':'text',
          'akey':'contact_email',
          'col':4,
          'placeholder':'email',
          'disabled':true,
        },
        {
          'componentType':'span',
          'akey':'span10',
          'col':2,
          'placeholder':'電話',
          'title':'',
        },
        {
          'componentType':'text',
          'akey':'contact_tel',
          'col':4,
          'placeholder':'電話',
          'disabled':true,
        },
        {
          'componentType':'span',
          'akey':'span11',
          'col':2,
          'placeholder':'行動電話',
          'title':'',
        },
        {
          'componentType':'text',
          'akey':'contact_m_tel',
          'col':4,
          'placeholder':'聯絡行動電話',
          'disabled':true,
        },
        {
          'componentType':'span',
          'akey':'span12',
          'col':2,
          'placeholder':'備註',
          'title':'',
        },
        {
          'componentType':'text',
          'akey':'contact_memo',
          'col':10,
          'placeholder':'備註',
          'disabled':true,
        },
        {
          componentType:'span',
          col:12,
          placeholder:'匯款設定(系統管理者與管理部帳號權限修改才生效)'
        },
        {
          componentType:'span',
          col:2,
          placeholder:'匯款帳號'
        },
        {
          componentType:'text',
          akey:'remit_bank_no',
          col:2,
          placeholder:'銀行代碼(3碼)',
        },
        {
          componentType:'text',
          akey:'remit_bankbranch_no',
          col:2,
          placeholder:'分行代碼(4碼)',
        },
        {
          componentType:'text',
          akey:'remit_id',
          col:6,
          placeholder:'帳號',
        },
        {
          componentType:'span',
          col:2,
          placeholder:'銀行/分行名',
          ttile:'顯示用,看代碼不看名稱'
        },
        {
          componentType:'text',
          akey:'remit_bank_cname',
          col:7,
          placeholder:'銀行名稱(請和代碼相符)',
          title:'與代碼不符時以代碼為準'
        },
        {
          componentType:'text',
          akey:'remit_bankbranch_cname',
          col:3,
          placeholder:'分行名稱(請和代碼相符)',
          title:'與代碼不符時以代碼為準'
        },
        {
          componentType:'span',
          col:2,
          placeholder:'匯款對象'
        },
        {
          componentType:'text',
          akey:'remit_title',
          col:7,
          placeholder:'匯款對象抬頭(必要)',
        },
        {
          componentType:'text',
          akey:'remit_name',
          col:3,
          placeholder:'受款人(非必要)',
        },
        {
          componentType:'span',
          col:2,
          placeholder:'匯款email'
        },
        {
          componentType:'text',
          akey:'remit_email',
          col:10,
          placeholder:'email(玉山需50字以內)',
        },
        {
          componentType:'text',
          akey:'remit_tel',
          col:4,
          placeholder:'匯款聯絡電話',
        },
        {
          componentType:'text',
          akey:'remit_m_tel',
          col:4,
          placeholder:'匯款聯絡手機',
        },
        {
          componentType:'text',
          akey:'remit_fax',
          col:4,
          placeholder:'匯款傳真',
        },
        {
          'componentType':'b-button',
          'akey':'button_cancel',
          'col':6,
          'placeholder':'返回',
          'title':'',
          'execCallback':this.cbCancel
        },
        {
          'componentType':'b-button',
          'akey':'button_save',
          'col':6,
          'placeholder':'更新',
          'title':'',
          'execCallback':this.saveMerchant
        },
      ],
    }
  },
  methods: {
    saveMerchant () {
      if (this.FocusedMerchant.remit_bank_no.length != 3) {
        this.$bus.fnShowInfo('銀行代碼3碼數字,左補0補到3碼')
        this.$refs.merchantInfoForm.setFocus('remit_bank_no')
        return
      }
      if (this.FocusedMerchant.remit_bankbranch_no.length === 0) {
        this.$bus.fnShowInfo('分行代碼不能為空')
        this.$refs.merchantInfoForm.setFocus('remit_bankbranch_no')
        return
      }
      this.cbSave(this.FocusedMerchant)
      return
      /*this.parentRef['FocusedMerchant']
      let rptParam = {
        'module':'admin_manage',
        'method':'updateMerchant',
        'merchant_id': this.parentRef['FocusedMerchant'].merchant_id,
        'invoice_type':this.parentRef['FocusedMerchant'].invoice_type,
        'supplier_address':this.parentRef['FocusedMerchant'].supplier_address,
        'person_in_charge':this.parentRef['FocusedMerchant'].person_in_charge
      }
      this.$bus.apiCall(rptParam, function (data, vm) {
        if (data.ok === 0) {
          vm.$bus.fnShowInfo(data.msg)
          vm.isLoading = false
          return
        }
        //就是parentRef了...所以不用管
        vm.$bus.fnShowInfo('設定成功')
        //先這樣關掉吧,cbSave是父組件負責存檔那樣先不要那樣做
        vm.cbCancel()
      }, this)*/
    },
  },
  computed: {
    parentRef () {
      if (this.parentVue) {
        return this.parentVue
      }
      else {
        return this
      }
    },
    FocusedMerchant () {
      return this.parentRef['FocusedMerchant']?this.parentRef['FocusedMerchant']:{}
    },
  },
  created() {
    
  },
  mounted() {
    if (!['sys_admin','mgr_dept'].includes(this.$bus.session.role_type)) {
      this.$refs.merchantInfoForm.setDisabled('remit_bank_no')
      this.$refs.merchantInfoForm.setDisabled('remit_bankbranch_no')
      this.$refs.merchantInfoForm.setDisabled('remit_id')
      this.$refs.merchantInfoForm.setDisabled('remit_title')
      this.$refs.merchantInfoForm.setDisabled('remit_email')
      this.$refs.merchantInfoForm.setDisabled('remit_name')
      this.$refs.merchantInfoForm.setDisabled('remit_bank_cname')
      this.$refs.merchantInfoForm.setDisabled('remit_bankbranch_cname')
      this.$refs.merchantInfoForm.setDisabled('remit_tel')
      this.$refs.merchantInfoForm.setDisabled('remit_m_tel')
      this.$refs.merchantInfoForm.setDisabled('remit_fax')
    }
  },
  watch: {
    
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
